export default __webpack_public_path__ + "static/media/IMG_5332.f319e14b.PNG";